const data = {
  Archive: 'Архив',
  Open: 'Ожидает оплаты',
  Paid: 'Оплачено',
  StartPaid: 'Ожидает оплаты',
  Cancel: 'Отменено',
};

const reducer = (state = data) => state;

export default reducer;
